import { MatDateFormats } from '@angular/material/core';
import * as moment from 'moment';

export const USER_LANGUAGE = window.navigator['language']
  || window.navigator['userLanguage']
  || window.navigator['browserLanguag']
  || window.navigator['systemLanguage']
  || 'pt-BR';

moment.locale(USER_LANGUAGE);

export const LOCALE_DATA = moment.localeData();

export const MOMENT_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: LOCALE_DATA['_longDateFormat']['L']
  },
  display: {
    dateInput: LOCALE_DATA['_longDateFormat']['L'],
    monthYearLabel: 'MMMM Y',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM Y'
  }
};


export const DATE_RANGE_PICKER_PRESETS: Array<any> = [
  {
    label: 'Últimos 7 dias',
    start: moment().subtract(7, 'days').startOf('days').toDate(),
    end: moment().startOf('days').toDate()
  },
  {
    label: 'Semana passada',
    start: moment().startOf('weeks').subtract(1, 'weeks').toDate(),
    end: moment().endOf('weeks').subtract(1, 'weeks').toDate()
  },
  {
    label: 'Últimos 30 dias',
    start: moment().subtract(1, 'months').startOf('days').toDate(),
    end: moment().startOf('days').toDate()
  },
  {
    label: 'Mês passado',
    start: moment().subtract(1, 'months').startOf('months').toDate(),
    end: moment().subtract(1, 'months').endOf('months').toDate()
  }
];

export const DATE_RANGE_PICKER_START: Date = moment().startOf('weeks').toDate();

export const DATE_RANGE_PICKER_END: Date = moment().endOf('weeks').toDate();
